/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RefreshTokenDtoRefreshTokenDto } from '../../models/refresh-token-dto-refresh-token-dto';

export interface UserControllerRefresh$Params {
      body: RefreshTokenDtoRefreshTokenDto
}

export function userControllerRefresh(http: HttpClient, rootUrl: string, params: UserControllerRefresh$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, userControllerRefresh.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'accessToken'?: string;
      }>;
    })
  );
}

userControllerRefresh.PATH = '/api/user/refresh';
